"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparisonOperatorEnum = void 0;
var ComparisonOperatorEnum;
(function (ComparisonOperatorEnum) {
    ComparisonOperatorEnum["GREATER_THAN"] = ">";
    ComparisonOperatorEnum["GREATER_THAN_OR_EQUAL"] = ">=";
    ComparisonOperatorEnum["LESS_THAN"] = "<";
    ComparisonOperatorEnum["LESS_THAN_OR_EQUAL"] = "<=";
})(ComparisonOperatorEnum || (exports.ComparisonOperatorEnum = ComparisonOperatorEnum = {}));
